import { render, staticRenderFns } from "./ComponentFrameSub.vue?vue&type=template&id=4b7c9246&scoped=true"
import script from "./ComponentFrameSub.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentFrameSub.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7c9246",
  null
  
)

export default component.exports